var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18ZM13 4L18 9H13V4ZM7 8H10V10H7V8ZM7 12H17V14H7V12ZM7 16H17V18H7V16Z",
    fill: "#5D616C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.992 3.894L6.263 5.304V6H5.75V5.304L5.021 3.894H5.603L6.011 4.776L6.416 3.894H6.992ZM9.7337 3.894V6H9.2207V4.737L8.7497 6H8.3357L7.8617 4.734V6H7.3487V3.894H7.9547L8.5457 5.352L9.1307 3.894H9.7337ZM10.7656 5.604H11.4376V6H10.2526V3.894H10.7656V5.604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYml);
export default __webpack_public_path__ + "static/media/YML.0dee3ca6f9fb2c507057d2afe32ab95c.svg";
export { ForwardRef as ReactComponent };